(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locator')) {
    class StoreLocator extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('[data-store-card]'));
        this.search = this.querySelector('[data-store-search]');
        this.empty = this.querySelector('[data-store-empty]');
        this.locations = this.cards.map((card) => {
          const data = JSON.parse(card.querySelector('[data-store-data]').textContent);
          return { card, ...data, marker: null };
        });

        this.search?.addEventListener('input', () => this.filter());
        this.loadLeaflet().then(() => this.initMap());
      }

      loadLeaflet() {
        if (window.L) return Promise.resolve();
        if (window.chispaLeafletPromise) return window.chispaLeafletPromise;
        window.chispaLeafletPromise = new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
          script.crossOrigin = '';
          script.onload = resolve;
          script.onerror = reject;
          document.head.appendChild(script);
        });
        return window.chispaLeafletPromise;
      }

      initMap() {
        const mapElement = this.querySelector('[data-store-map]');
        if (!mapElement || mapElement.dataset.initialized) return;
        mapElement.dataset.initialized = 'true';
        this.map = L.map(mapElement, { scrollWheelZoom: false }).setView([-35.5, -71.5], 5);
        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
        }).addTo(this.map);

        const bounds = [];
        this.locations.forEach((location) => {
          const lat = Number.parseFloat(location.latitude);
          const lng = Number.parseFloat(location.longitude);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
          const popup = document.createElement('div');
          const name = document.createElement('strong');
          name.textContent = location.name;
          popup.appendChild(name);
          if (location.address) popup.appendChild(document.createTextNode(location.address));
          location.marker = L.marker([lat, lng]).addTo(this.map).bindPopup(popup);
          location.marker.on('click', () => location.card.scrollIntoView({ behavior: 'smooth', block: 'nearest' }));
          bounds.push([lat, lng]);
          location.card.addEventListener('click', (event) => {
            if (event.target.closest('a') || !location.marker) return;
            this.map.setView([lat, lng], 15);
            location.marker.openPopup();
          });
        });
        this.map.setView([-33.39, -70.55], 12);
      }

      filter() {
        const query = (this.search?.value || '').trim().toLocaleLowerCase('es');
        let visible = 0;
        this.locations.forEach((location) => {
          const text = `${location.name} ${location.address}`.toLocaleLowerCase('es');
          const matches = !query || text.includes(query);
          location.card.hidden = !matches;
          if (location.marker && this.map) {
            if (matches) location.marker.addTo(this.map);
            else location.marker.removeFrom(this.map);
          }
          if (matches) visible += 1;
        });
        if (this.empty) this.empty.hidden = visible !== 0;
      }
    }
    customElements.define('store-locator', StoreLocator);
  }

  } catch(e) { console.error(e); }
})();
})();
